<script setup lang="ts">
import { useVModel } from "@vueuse/core";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import Textarea from "primevue/textarea";
import { defineEmits, defineProps } from "vue";
import Tooltip from "@/components/shared/Tooltip/PrimeVueTooltip.vue";

const props = defineProps({
  modelValue: {
    type: Object,
    required: false,
    default: () => {},
  },
});

const emit = defineEmits(["update:modelValue"]);
const programSession = useVModel(props, "modelValue", emit);
</script>
<template>
  <Accordion :active-index="1">
    <AccordionTab :pt="{ root: { 'data-testid': 'promotional-settings-section' }, headerIcon: { class: 'text-gray-900' } }">
      <template #header>
        <span class="text-sm font-semibold text-gray-900 uppercase flex flex-1 items-center cursor-pointer">Session-Specific Advising Instructions</span>
      </template>
      <div class="card flex flex-col justify-center">
        <div class="flex flex-row">
          <h1 class="text-sm font-semibold text-gray-700">Instructions</h1>
          <Tooltip message="Add context or tips for advising students on this session — what makes it custom, what to emphasize, and any important session-specific guidance. This will be used by the AI Advisor to answer student questions." />
        </div>
        <Textarea
          :model-value="programSession.advising_notes"
          @update:model-value="(val) => programSession.advising_notes = (!val || val.trim() === '') ? undefined : val"
          rows="7"
          cols="30"
        />
      </div>
    </AccordionTab>
  </Accordion>
</template>
